import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { GreyBox } from "../../components/grey-box";
import { usePreviewContext } from "../../preview-context";
import { PreviewWithSidebarChannel } from "./preview-with-sidebar-channel";
import { PreviewWithSidebarChannelNotify } from "./preview-with-sidebar-channel-notify";
import { PreviewWithSidebarConnection } from "./preview-with-sidebar-connection";
import { PreviewWithSidebarNotify } from "./preview-with-sidebar-notify";
import { PreviewWithSidebarRecipients } from "./preview-with-sidebar-recipients";

export const PreviewWithSidebar: FC = () => {
  const { preview_info } = usePreviewContext();

  if (!preview_info.data?.classifyData || preview_info.data.classifyData.type === "unknown")
    return (
      <Stack direction="column" spacing={1}>
        <GreyBox>
          <Typography variant="body2" color="textSecondary">
            Previewing with Test data - no recipient setup is selected.
          </Typography>
        </GreyBox>
      </Stack>
    );

  const { type, data } = preview_info.data.classifyData;

  return (
    <Stack direction="column" spacing={1} sx={{ p: 2 }}>
      {type === "recipients" && <PreviewWithSidebarRecipients data={data} />}
      {type === "connection" && <PreviewWithSidebarConnection data={data} />}
      {type === "notify" && <PreviewWithSidebarNotify data={data} />}
      {type === "channel" && <PreviewWithSidebarChannel data={data} />}
      {type === "channel_notify" && <PreviewWithSidebarChannelNotify data={data} />}
    </Stack>
  );
};
